import React, {useEffect, useRef, useState,} from "react";
import {DateRangePickerProps} from './DateRangePicker.props';
import moment from 'moment-timezone';

import DatePicker from '../../../lib/react-bootstrap-daterangepicker';
import '../../../lib/bootstrap-daterangepicker/daterangepicker.css';
import './DateRangePicker.styles.css';
import {Text} from '../Text';
import { ReactComponent as Calendar } from "../../../assets/images/calendar.svg";
import {isMobileOnly} from "react-device-detect";

function normalizeDate(input: string | Date | any, timezone?: any): any {
    if (!input) {
        return moment();
    }
    if (moment.isMoment(input)) {
        return input.clone().tz(moment.tz.guess(), true);
    }
    if (input instanceof Date) {
        return moment(input);
    }
    if (typeof input === "string") {
        return moment.utc(input, "YYYY-MM-DD HH:mm:ss", true).tz(timezone);
    }
    return moment(input as any);
}

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
    textFilter,
    linkIcon= true,
    fontSize,
    color,
    colorText,
    width,
    padding,
    margin,
    cssClass,
    onDateFilter,
    start,
    end,
    dates,
    titleCalendar='Reported At:',
    handleApplyDateRange,
    colorInput='#ffffff',
    dateKeyRef,
    maxSpan,
}) => {

    let tz_name = 'Etc/UTC';
    const localStorageUserData = localStorage.getItem('userData');
    if(localStorageUserData) {
        const parseUserData = JSON.parse(localStorageUserData)
        tz_name = parseUserData["tz_name"]
    }

    moment.tz.setDefault(tz_name);
    
    let [isSingleDate, setSingleDate] = useState({isSingle: window.innerWidth < 768 || isMobileOnly})
    const [seed, setSeed] = useState(1);

    const [displayDate, setDisplayDate] = useState({
        start: normalizeDate(dates?.startDate || start, tz_name),
        end: normalizeDate(dates?.endDate || end, tz_name),
    });
    
    const keyRef = useRef();

    const handleApply = (event:any ,picker:any)=> {
        if(event.type === "apply"){
            handleApplyDateRange({
                startDate: moment(picker.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate: moment(picker.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
            });
            setDisplayDate({
                  start: picker.startDate.tz(tz_name),
                  end: picker.endDate.tz(tz_name)
              }
            )
            onDateFilter && onDateFilter(picker.startDate.utc().format('YYYY-MM-DD HH:mm:ss'), picker.endDate.utc().format('YYYY-MM-DD HH:mm:ss'))
        }
    }

    const dateRange = {
        Today: [moment().toDate(), moment().toDate()],
        Yesterday: [
            moment().subtract(1, 'days').toDate(),
            moment().subtract(1, 'days').toDate(),
        ],
        'Last 7 Days': [
            moment().subtract(6, 'days').toDate(),
            moment().toDate(),
        ],
        'Last 30 Days': [
            moment().subtract(29, 'days').toDate(),
            moment().toDate(),
        ],
        'This Month': [
            moment().startOf('month').toDate(),
            moment().endOf('month').toDate(),
        ],
        'Last Month': [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
        ],
    }
    
    const resizeHandler = () => {
        setSeed(Math.random());
        setSingleDate({isSingle: window.innerWidth < 768 || isMobileOnly})
    };
    
    useEffect(() => {
        window.addEventListener('resize', resizeHandler);
        //@ts-ignores

        return () => {
            window.removeEventListener('resize', resizeHandler);
        }
    }, []);

    return (
        <div className="date-range-filter" style={{margin}}>
            <Text cssClass='date-range-title' children={textFilter} color={colorText} fontSize={14} margin='0 5px'/>
            <DatePicker
                ref={keyRef.current}
                key={seed}
                onApply={handleApply}
                onCancel={() => console.log('onCancel')}
                onEvent={() => console.log('onEvent')}
                onHide={() => console.log('onHide')}
                onHideCalendar={() => console.log('onHideCalendar')}
                onShow={() => console.log('onShow')}
                onShowCalendar={() => console.log('onShowCalendar')}
                initialSettings={
                    {
                        startDate: displayDate.start,
                        endDate: displayDate.end,
                        ranges: dateRange,
                        singleDatePicker: isSingleDate.isSingle,
                        alwaysShowCalendars: true,
                        maxSpan,
                    }
                }
            >
                <input type="text" className={"form-control " + cssClass} inputMode={'none'}  readOnly={true} name='input-date-range'/>
            </DatePicker>
            <span className='date-label'>{titleCalendar}<span className='date-value'>{(moment(displayDate.start).format('DD/MM/YYYY')) + ' - ' + (moment(displayDate.end).format('DD/MM/YYYY'))}</span>{
              linkIcon? <Calendar fill={'#345C8B'}/> : ''}</span>
        </div>
    );
};
